/*
  Sengehuset motion: reveal content once as it scrolls into view.
  - Runs only when <html> has .sh-motion (set inline in theme.liquid when the visitor has not
    asked for reduced motion and the theme editor is not open), so content is never hidden
    without this script.
  - Grid children get a short stagger so rows arrive together but not all at once.
  - Doodles draw their strokes in (CSS, via .is-in).
*/
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('sh-motion')) return;
  window.shMotionReady = true;

  var SINGLE = [
    '.sh-section-head',
    '.sh-guide__intro',
    '.sh-faq__intro',
    '.sh-reviews__head',
    '.sh-story__media',
    '.sh-story__copy',
    '.sh-collhero__grid',
    '.sh-collseo__grid',
    '.sh-tabs__all',
    '.sh-footer__top',
    '.sh-doodle'
  ];
  var GROUPS = [
    '.sh-cats__list',
    '.sh-guide__list',
    '.sh-reviews__rail',
    '.sh-faq__list',
    '.sh-tabs__panel:not([hidden]) .product-grid',
    '#product-grid',
    '.related-products .product-grid'
  ];

  var targets = [];
  function mark(el, delay) {
    if (el.hasAttribute('data-reveal')) return;
    el.setAttribute('data-reveal', '');
    if (delay) el.style.transitionDelay = delay + 'ms';
    targets.push(el);
  }

  function collect(scope) {
    SINGLE.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) {
        if (!el.closest('.sh-hero')) mark(el, 0);
      });
    });
    GROUPS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          mark(child, Math.min(i, 6) * 70);
        });
      });
    });
  }

  function reveal(el) {
    el.classList.add('is-in');
  }

  collect(document);

  if (!('IntersectionObserver' in window)) {
    targets.forEach(reveal);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  targets.forEach(function (el) { io.observe(el); });

  // Content that arrives later (tab switches, filtering, recommendations) is shown straight away.
  new MutationObserver(function () {
    document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
    });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });

  // Safety net: never leave anything hidden, e.g. after a jump to an anchor.
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < window.innerHeight) reveal(el);
      });
    }, 1500);
  });
})();
